<template>
    <div id="fahrzeugBearbeiten">
        <h1>{{ this.$props.fahrzeug.name }}</h1>
        <center id="fahrzeugContainer">
            <span class="buttonsFahrzeugLinks col-3">
                <!--<button class="buttonTop mada buttonLinks fahrzeugButton">Fa</button>-->
                <span v-for="fach in this.faecherLinks" :key="fach.fachID">
                    <button class="buttonLinks fahrzeugButton" @click="this.openFahrzeugFach(fach)">{{fach.name}}</button>
                </span>
                <!--<button class="buttonLinks fahrzeugButton">Heck</button>-->
            </span>
            <!--<span class="col-6 fahrzeugContainer">-->
            <img class="Fahrzeug" :src="this.image" @click="this.changeImage()">
            <!--</span>-->
            <span class="buttonsFahrzeugRechts col-3">
                <!--<button class="buttonTop mada buttonRechts fahrzeugButton">Ma</button>-->
                <span v-for="fach in this.faecherRechts" :key="fach.fachID">
                    <button class="buttonLinks fahrzeugButton" @click="this.openFahrzeugFach(fach)">{{fach.name}}</button>
                </span>
                <!--<button class="buttonRechts fahrzeugButton">Dach</button>-->
            </span>
        </center>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Swal from 'sweetalert2'
import axios from 'axios';

export default {
    name: 'MTA2',
    components: {
        Header,
        Footer
    },
    props: {
        fahrzeug: Object,
    },
    data() {
        return {
            image: "",
            faecher: [],
            anzahlFaecher: "",
            fachHeck: {},
            faecherLinks: [],
            faecherRechts: []
        }
    },
    methods: {
        async deleteFile(filePath) {
            try {
                const response = await fetch('https://feuerwehr-server.org:5000/delete-image', {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ filePath: filePath }) // Pfad der Datei senden
                });

                const result = await response.json();
                if (result.success) {
                    console.log('Datei erfolgreich gelöscht:', result.message);
                } else {
                    console.error('Fehler beim Löschen der Datei:', result.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        async changeImage(){
            var image = this.$props.fahrzeug.imagePath;
            var html = "";
            html += `<img src="`+ image + `" style="height: 6rem"><br>`;
            html += `<input type="file" id="file" class="swal2-input" placeholder="Bild hochladen" value="` + image + `">`;

            const { value: formValues } = await Swal.fire({
                title: "Bild bearbeiten",
                html: html,
                focusConfirm: false,
                preConfirm: () => {
                    var file = document.getElementById("file").files[0];
                    if(file == null){
                        file = image;
                    }
                    return { file };
                }
            });

            if (formValues) {
                const file = formValues.file;

                // FormData erstellen, um Bild zu senden
                const formData = new FormData();
                formData.append('file', file);

                // Upload der Datei ans Backend
                try {
                    await this.deleteFile(this.$props.fahrzeug.imagePath);
                    
                    const response = await fetch('https://feuerwehr-server.org:5000/upload-image-endpoint', {
                        method: 'POST',
                        body: formData
                    });

                    const result = await response.json(); // der Pfad oder das Ergebnis vom Backend
                    if (result.success) {
                        // Wenn der Upload erfolgreich war, Geraet anlegen
                        const imagePath = result.filePath; // Bildpfad vom Backend
                        const fahrzeugObj = {
                            feuerwehrID: this.$props.fahrzeug.feuerwehrID,
                            fahrzeugID: this.$props.fahrzeug.fahrzeugID,
                            name: this.$props.fahrzeug.name,
                            imagePath: imagePath
                        }
                        await this.updateFahrzeug(fahrzeugObj); // Geraet mit Bildpfad erstellen
                        Swal.fire("Bild erfolgreich gespeichert", "", "success");
                        this.image = result.filePath;
                    }
                } catch (error) {
                    console.error('Error uploading the file:', error);
                }
            }
        },
        async getFaecher(){
            try{
                var fahrzeugID = this.$props.fahrzeug.fahrzeugID;
                const response = await axios.get(
                    'https://feuerwehr-server.org:5000/fach',
                    { params: { fahrzeugID: fahrzeugID } }
                );
                console.log(response.data)
                return response.data;
            } catch (err){
                console.log(err);
                //return false;
            }
        },
        splitArray(faecher){
            faecher.forEach((element, index) => {
                if(index % 2 === 0){
                    this.faecherLinks.push(element);
                } else{
                    this.faecherRechts.push(element);
                }
            })
        },
        openFahrzeugFach(fachObj){
            var fahrzeug = { fachObj: fachObj, fahrzeugObj: this.$props.fahrzeug}
            this.$emit('openFahrzeugFach', fahrzeug);
        },
        async updateFahrzeug(fahrzeugData){
            try {
                const response = await axios.put('https://feuerwehr-server.org:5000/updateFahrzeug', fahrzeugData);
                return true;
            } catch (err) {
                console.error(err);
                return false;
            }
        }
    },
    async created() {
        this.image = this.$props.fahrzeug.imagePath;
        console.log(this.image);
        this.faecher = await this.getFaecher();
        this.splitArray(this.faecher);
    },

    mounted() {
        
    }
}
</script>

<style lang="scss">
#fahrzeugBearbeiten {
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;

    h1{
        margin-top: 2rem;
    }

    #fahrzeugContainer{
        display: flex;
        justify-content: center;
    }
    .buttonsFahrzeugLinks {
        height: 100%;
        padding-right: 0px !important;
    }

    .buttonsFahrzeugRechts {
        height: 100%;
        padding-left: 0px !important;
    }

    .buttonTop {
        margin-top: 1rem;
    }

    .fahrzeugButton {
        display: inline-block;
        /*width: 3.8rem;*/
        width: 95%;
        height: 3.8rem;
        margin-bottom: 0.15rem !important;
        font-size: 1.4rem !important;
    }

    .buttonRechts {
        border-right: 3px solid black;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        background-color: inherit;
        color: black;
        border-left: transparent;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        outline: none !important;


        border-left: 3px solid black;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .buttonLinks {
        border-left: 3px solid black;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        background-color: inherit;
        color: black;
        border-right: transparent;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        outline: none !important;


        border-right: 3px solid black;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }    

    .mada {
        margin-bottom: 2rem !important;
    }

    .Fahrzeug {
        /*height: auto;
    width: 100% !important;
    max-width:80% !important;*/
        height: 25rem;
        width: auto;
    }

    .fahrzeugContainer {
        padding: 0px !important;
    }
}
</style>
